import React from 'react'
import './CloseButton.sass'

const CloseButton = ({className, onClick}) => {

    return (
        <div className={className ? className : "closeButton"} onClick={() => {onClick()}}>
            <i style={{color: '#80bdff'}} className="fas fa-times"/>
        </div>
    )
}
export default CloseButton